<!-- Le menu est DEHORS du bloc gardé, et doit le rester : c'est lui qui porte l'écoute clavier
     (F1/F2/F3). Le démonter le temps d'une remise à zéro couperait la main qui vient d'appuyer. -->
<app-menu-common url="sales"></app-menu-common>
<!-- `mounted` : voir QuotationComponent.resetToNewOrder(). Le passage à false détruit tout ce
     sous-arbre — c'est ce qui garantit que la vente suivante ne reprend RIEN de la précédente,
     y compris ce que les composants enfants gardaient hors du formulaire. -->
@if (mounted && formGroup && !dataError && !NoDocumentError) {
  <div>
    <div class="pageheader" [formGroup]="formGroup" [ngClass]="currentOrderClass">
      <!-- ═══════════════════════════════════════════════════════════════════════════════════
      EN-TÊTE DE SAISIE — deux bandes horizontales au lieu de quatre rangées empilées.
      Ce qui coûtait la hauteur : quatre rangées « libellé (160px) / champ (400px) » dans
      une colonne large de ~1230px dont elles n'utilisaient que 560, pendant que la moitié
      droite étalait deux pastilles de 32px sur toute la hauteur (space-around).
      Bande 1 « identité » : icône, titre et sous-titre sur une SEULE ligne de base, puis à
      droite les métadonnées consultées (site, créé le, FSE, n° de pièce, état, date).
      Bande 2 « saisie »   : le libellé passe AU-DESSUS du champ — c'est ce déplacement qui
      rend les 160px de colonne consommés sur chacune des quatre rangées, et qui permet
      de loger quatre contrôles là où il n'en tenait qu'un.
      AUCUN texte ne quitte l'écran : le sous-titre reste affiché, « Créé le » garde son
      appel intact (simplement gardé par un @if), aucun champ n'est masqué ni replié.
      ═══════════════════════════════════════════════════════════════════════════════════ -->
      <!-- ─── BANDE 1 — IDENTITÉ DU DOCUMENT ─────────────────────────────────────────────── -->
      <div class="hdr-identity">
        <mat-icon class="pagetitle-icon">{{ currentOrderIcon }}</mat-icon>
        <!-- Titre et sous-titre partagent une ligne de base. Le sous-titre paraphrase le titre
        sur trois types de document sur quatre : il ne mérite pas une ligne à lui, mais il
        n'est PAS supprimé pour autant — `flex: 0 4 auto` le fait se tronquer AVANT le
        titre quand la place manque, et son infobulle rend le texte intégral (utile sur
        AVOIR, dont le sous-titre est le seul à réellement informer : « reprise de matériel »). -->
        <div class="hdr-title-block">
          <div class="pagetitle">
            @if (!id && !parentOrderId) {
              <span>Nouvelle&nbsp;</span>
            }
            <span>{{ currentOrderLabel }}</span>
          </div>
          @if (currentOrderSubtitle) {
            <div class="pagesubtitle text-muted" [matTooltip]="currentOrderSubtitle">{{ currentOrderSubtitle }}</div>
            @if (parentOrderId) {
              <a class="hdr-chip hdr-parent-chip" [routerLink]="['/sales/quotation', parentOrderId]" [matTooltip]="parentOrderTooltip">
                <mat-icon class="hdr-parent-chip-icon">open_in_new</mat-icon>
                <span>N° {{ parentOrderId | formatInteger }}</span>
              </a>
            }
            @if (avoirOrderId) {
              <a class="hdr-chip hdr-parent-chip" [routerLink]="['/sales/quotation', avoirOrderId]" matTooltip="Accéder à l'avoir de cette pièce">
                <mat-icon class="hdr-parent-chip-icon">open_in_new</mat-icon>
                <span>Avoir N° {{ avoirOrderId | formatInteger }}</span>
              </a>
            }
          }
        </div>
        <!-- Groupe de métadonnées poussé à droite par `margin-left: auto` (et non par un
        <span class="spacer">, qui est `flex: 1 1 auto` et consommerait une ligne entière
          pour lui seul si la bande venait à se replier sur un écran étroit). -->
        <div class="hdr-meta-group">
          <!-- Provenance de la pièce : le poste de travail et l'établissement qui l'ont SAISIE,
            résolus depuis l'id de station porté par la commande (cf. orderStationLabel).
            Auparavant on affichait `loginService.currentstore`, c'est-à-dire le magasin de
            l'UTILISATEUR EN TRAIN DE REGARDER : sur une commande passée dans un autre magasin,
            la valeur annoncée était fausse. -->
          @if (orderStationLabel) {
            <span class="hdr-chip" matTooltip="Poste de travail et établissement où cette commande a été saisie">{{ orderStationLabel }}</span>
          }
          <!-- Les FSE sont un fait attaché au DOCUMENT (fseOrders arrive du serveur avec la
            commande, pas avec le client) : leur place est auprès de l'état.
            AUCUNE borne de largeur : les numéros de FSE sont exactement ce que l'utilisateur
            vient chercher ici (les reporter dans le module FSE). `fseOrders` n'est pas borné
            côté serveur, et une ellipsis les rendrait DÉFINITIVEMENT illisibles — l'infobulle
            est explicative, elle ne contient pas les identifiants. La puce se replie donc sur
            plusieurs lignes (white-space: normal) : le coût vertical n'est payé que sur les
            commandes qui portent des FSE, et il est préférable à une perte d'information. -->
          @if (fseOrders && fseOrders.length > 0) {
            <span class="hdr-chip hdr-fse" matTooltip="Feuilles de soins électroniques déjà rattachées à cette commande">
              &#x2757; FSEs existantes :
              @for (fse of fseOrders; track fse) {
                <span class="">{{ fse.id }}&nbsp;</span>
              }
            </span>
          }
          <!-- `id="orderid"` reste posé sur le nœud qui ne contient QUE le numéro : son
            `textContent` vaut toujours « 123 » et non « N°123 », ce qui préserve tout script
            e2e hors dépôt qui comparerait le texte de cette ancre. Le préfixe « N° » vit dans
            un frère, et c'est le conteneur .hdr-orderid qui porte l'habillage de puce. -->
          @if (id) {
            <div class="hdr-orderid"
              ><span class="hdr-num">N°</span><span id="orderid">{{ id | formatInteger }}</span></div
            >
            @if (docRef) {
              <div class="hdr-docref"
                [class.docref-ticket]="docRef.startsWith('TK-')"
                [class.docref-facture]="docRef.startsWith('FAC-')"
                [class.docref-avoir]="docRef.startsWith('AV-')"
                matTooltip="Référence officielle de pièce scellée (BOFIP ISCA)">
                <mat-icon class="hdr-docref-icon">verified</mat-icon>
                <span>{{ docRef }}</span>
              </div>
            }
          }
          <!-- Fil des états : chaque passage porté par `dates`, dans l'ordre chronologique. Il
            REMPLACE l'ancienne date d'état seule (`datCurrentState`) — la dernière étape du fil
            porte exactement la même valeur, l'afficher deux fois sur la même ligne n'apprenait
            rien. Le séparateur « › » est posé en CSS pour qu'il ne soit ni sélectionné ni lu par
            un lecteur d'écran. Format court à l'écran, date complète en infobulle.
            Le fil se termine sur le BADGE d'état, placé juste après (voir plus bas) : c'est lui
            qui nomme la dernière étape, laquelle n'affiche donc que sa pastille et son heure. -->
          @if (stateTrail.length) {
            <span class="hdr-trail">
              @for (step of stateTrail; track step.key; let isLast = $last) {
                <span class="hdr-trail-step" [class.current]="step.current" [matTooltip]="step.label + ' — ' + (step.date | date: 'dd/MM/yy HH:mm:ss')">
                  <span class="hdr-trail-dot" [ngClass]="'dot-' + step.color"></span>
                  <!-- Libellé masqué UNIQUEMENT quand l'étape courante clôt le fil : le badge qui
                    suit immédiatement porte alors le même mot, l'écrire deux fois côte à côte
                    n'apprend rien. Si l'état courant n'est PAS la dernière étape (retour en
                    arrière), le badge n'est plus adjacent : chaque étape garde son nom. -->
                  @if (!(step.current && isLast)) {
                    <span class="hdr-trail-label">{{ step.label }}</span>
                  }
                  <span class="hdr-trail-date">{{ step.date | date: 'dd/MM HH:mm' }}</span>
                </span>
              }
            </span>
          }
          <!-- Le badge d'état ferme la ligne, à l'extrême droite : le fil se lit de gauche à droite
            dans l'ordre chronologique et CULMINE sur l'état courant. Il vient donc après la
            dernière étape — donc après sa date — et non plus avant le fil, où il annonçait la
            conclusion avant le récit. -->
          <span class="state-badge badge" [ngClass]="getOrderColor(formGroup.value.state)" [class.valid]="formGroup.value.state === SalesOrderState.QUOTE">
            {{ getOrderLabel(this.formGroup.controls.state.value, remainder) }}
          </span>
          @if (false) {
            <app-thumb-delivery-type [formGroup]="formGroup"></app-thumb-delivery-type>
          }
          <!-- <app-vignette-mode-delivery [formGroup]="formGroup"  ></app-vignette-mode-delivery> -->
        </div>
      </div>
      <!-- ─── BANDE FACTURES ENFANTS (CONTRAT DE LOCATION) ───────────────────────────────── -->
      @if (childInvoices && childInvoices.length > 0) {
        <div class="hdr-invoices-bar">
          <div class="hdr-invoices-lead">
            <mat-icon class="hdr-invoices-icon">receipt_long</mat-icon>
            <span class="hdr-invoices-label">Factures émises ({{ childInvoices.length }})&nbsp;:</span>
          </div>
          <div class="hdr-invoices-list">
            @for (inv of childInvoices; track inv.id) {
              <a class="hdr-child-link" [routerLink]="['/sales/quotation', inv.id]" [matTooltip]="'Ouvrir la facture N° ' + (inv.id | formatInteger) + (inv.amount_taxi ? ' (' + (inv.amount_taxi | number: '1.2-2') + ' € TTC)' : '')">
                <span>N°&nbsp;{{ inv.id | formatInteger }}</span>
              </a>
            }
          </div>
        </div>
      }
      <!-- ─── BANDE ACOMPTE VERSÉ ─────────────────────────────────────────────────────────── -->
      @if (depositInfo; as dep) {
        <div class="hdr-deposit-bar">
          <div class="hdr-deposit-lead">
            <mat-icon class="hdr-deposit-icon">verified</mat-icon>
            <span class="hdr-deposit-label">Acompte versé&nbsp;:</span>
            <span class="hdr-deposit-amount">{{ dep.amount | number: '1.2-2' }} € TTC</span>
            @if (dep.doc_ref) {
              <span class="hdr-deposit-ref">{{ dep.doc_ref }}</span>
            }
            <span class="hdr-deposit-sealed" matTooltip="Acompte scellé et chaîné dans le journal légal">
              <mat-icon class="sealed-icon">lock</mat-icon>
              Scellé
            </span>
          </div>
          <div class="hdr-deposit-actions">
            @if (dep.c_attach_id) {
              <button mat-stroked-button type="button" class="hdr-deposit-pdf-btn" (click)="viewDepositPdf(dep.c_attach_id)" matTooltip="Consulter la facture d'acompte scellée">
                <mat-icon>picture_as_pdf</mat-icon>
                Facture d'acompte
              </button>
            }
          </div>
        </div>
      }
      <!-- ─── BANDE 2 — SAISIE ───────────────────────────────────────────────────────────────
        Les quatre contrôles sont ÉLASTIQUES (flex-grow > 0) : ils absorbent toute la largeur
        disponible au lieu de laisser un vide au milieu, et les réglages d'affichage restent
        collés à droite. À 1920px les sélecteurs d'adresse font ~395px (contre 400px figés
        aujourd'hui, mais sur deux rangées) ; à 1280px ils tiennent encore sur une seule ligne. -->
      <div class="hdr-fields">
        <div class="hdr-field field-client">
          <div class="client-header-row">
            <span class="hdr-label">{{ isDistinctBeneficiary ? 'Payeur (facturation)' : 'Client' }}</span>
            <!-- Pièce enregistrée seulement (JP, 26/10) : F1 / F2 / F3 neuves pour ce client, toujours dans un nouvel onglet. -->
            @if (canOpenNewSale) {
              <span class="new-sale-acts">
                @for (k of NEW_SALE_KINDS; track k) {
                  <button type="button" class="new-sale-btn" [id]="'hdr-new-' + k" [matTooltip]="NEW_SALE_DOCUMENTS[k].customerTip" [attr.aria-label]="NEW_SALE_DOCUMENTS[k].label" (click)="openNewSale(k)">
                    <mat-icon>{{ NEW_SALE_DOCUMENTS[k].icon }}</mat-icon>
                  </button>
                }
              </span>
            }
            <label class="distinct-toggle" [matTooltip]="isDistinctBeneficiary ? 'Désactiver le tiers bénéficiaire' : 'Définir un bénéficiaire distinct pour la livraison'">
              <input type="checkbox" [checked]="isDistinctBeneficiary" [disabled]="isCustomerLocked(formGroup.controls.state.value)" (change)="onDistinctBeneficiaryChange($any($event.target).checked)" />
              <span>Livrer à un tiers</span>
            </label>
          </div>
          <div class="hdr-control">
            @if (isCustomerLocked(formGroup.controls.state.value)) {
              @if (customer && customer.id && customer.id > 0) {
                <a mat-button (click)="openPartnerDialog(customer.id)" [class.unidentified]="!customer" id="customername" class="primary hdr-link">{{ customer_label }}</a>
              } @else {
                <!-- style en ligne conservé volontairement : déplacer cette couleur en feuille
                  l'exposerait à la cascade de l'état désactivé de Material, pour un gain nul. -->
                <a mat-button disabled class="disabled hdr-link" style="color: gray">Non Renseigné</a>
              }
            } @else {
              <!-- Remove/Search client icon (magnifier) only on init state -->
              <!-- partnerChange = un AUTRE client est choisi (adresses par défaut) ; partnerUpdated =
              le client affiché a été modifié dans sa fiche, on le relit sans toucher aux choix faits ici. -->
              <app-search-partner [currentPartner]="customer" [showSelectionInInput]="true" [resetComponentSubject]="resetSearchPartnerSubject" (partnerChange)="customerChange($event)" (partnerUpdated)="customerRefreshed($event)"></app-search-partner>
            }
            <!-- disabledInteractive : un bouton désactivé « nu » n'émet aucun événement souris, donc
              aucune infobulle — or c'est elle qui dit POURQUOI la carte vitale est fermée. -->
            @if (id && cvVisible) {
              <button mat-icon-button class="cv-button" [disabled]="cvBlockedReason !== null" disabledInteractive [matTooltip]="cvTooltip" (click)="openRecipientsDialog()">
                <mat-icon class="cv_icon" svgIcon="carteVitale-icon"></mat-icon>
              </button>
            }
          </div>
        </div>
        <div class="hdr-field field-addr">
          <span class="hdr-label" matTooltip="Adresse de facturation">Adr. facturation</span>
          <smart-select class="hdr-select" height="30px" optionHeight="32px" [items]="customerAddresses" formControlName="addr_bill" [bindLabelFn]="formatAddress" bindValue="id"></smart-select>
        </div>
        <!-- `addr_deliv` est posté au submit. En mode tiers unique, il est sur cette ligne.
            En mode tiers multiple, il est déporté sur la ligne Bénéficiaire ci-dessous. -->
        @if (!isDistinctBeneficiary) {
          <div class="hdr-field field-addr">
            <span class="hdr-label" matTooltip="Adresse de livraison">Adr. livraison</span>
            <smart-select class="hdr-select" height="30px" optionHeight="32px" [items]="customerAddresses" formControlName="addr_deliv" [bindLabelFn]="formatAddress" bindValue="id"></smart-select>
          </div>
        }
        <!-- Pas de libellé au-dessus de celui-ci : il est [selectable]="false" et n'a aucun
            formControlName — il ne peut JAMAIS porter de valeur, donc son placeholder
            « Tarifs clients » reste affiché en permanence et fait office de libellé. En doubler
            le texte n'apporterait que du bruit ; l'infobulle dit ce que le placeholder ne dit
            pas, à savoir qu'on est en consultation. Le width="300px" est retiré : il vivait dans
            un hôte .head-input de 400px, soit 100px morts à sa droite. -->
        <div class="hdr-field field-prices">
          <smart-select class="hdr-select" matTooltip="Tarifs du client (consultation)" [disabled]="customer && customer?.lnk_partnerprices && customer?.lnk_partnerprices.length > 0 ? false : true" [selectable]="false" placeholder="Tarifs clients" height="30px" optionHeight="32px" [items]="$safeNavigationMigration(customer?.lnk_partnerprices)" bindLabel="name"></smart-select>
        </div>
        <!-- Réglages d'AFFICHAGE du tableau de lignes (@Input vers app-rentgeneral et
            app-quotationgeneral, aucun formControl, rien de persisté) : en fin de bande, dans le
            vide horizontal que `justify-content: space-around` étirait verticalement. Cible de
            clic maintenue à 30px — HT/TTC change le prix annoncé de vive voix à un client. -->
        <div class="hdr-toggles">
          <div class="toggle-group check">
            <input type="radio" name="ht_ttc" id="toggle-ht" [checked]="is_ht" (change)="is_ht = true" />
            <label for="toggle-ht" class="error">Prix HT</label>
            <input type="radio" name="ht_ttc" id="toggle-ttc" [checked]="!is_ht" (change)="is_ht = false" />
            <label for="toggle-ttc" class="success">Prix TTC</label>
          </div>
          <div class="toggle-group check">
            <input type="radio" name="group_packagings" id="toggle-lines-sep" [checked]="!group_packagings" (change)="group_packagings = false" />
            <label for="toggle-lines-sep">Lignes séparées</label>
            <input type="radio" name="group_packagings" id="toggle-lines-group" [checked]="group_packagings" (change)="group_packagings = true" />
            <label for="toggle-lines-group">Regroupées</label>
          </div>
        </div>
      </div>
      @if (isDistinctBeneficiary) {
        <div class="hdr-fields beneficiary-row">
          <div class="hdr-field field-client">
            <span class="hdr-label">Bénéficiaire (livraison)</span>
            <div class="hdr-control">
              @if (isCustomerLocked(formGroup.controls.state.value)) {
                @if (beneficiary && beneficiary.id && beneficiary.id > 0) {
                  <a mat-button (click)="openPartnerDialog(beneficiary.id)" [class.unidentified]="!beneficiary" id="beneficiaryname" class="primary hdr-link">{{ beneficiary_label }}</a>
                } @else {
                  <a mat-button disabled class="disabled hdr-link" style="color: gray">Non Renseigné</a>
                }
              } @else {
                <app-search-partner [currentPartner]="beneficiary" [showSelectionInInput]="true" [resetComponentSubject]="resetSearchBeneficiarySubject" (partnerChange)="beneficiaryChange($event)" (partnerUpdated)="beneficiaryRefreshed($event)"></app-search-partner>
              }
            </div>
          </div>
          <div class="hdr-field field-addr">
            <span class="hdr-label" matTooltip="Adresse de livraison du bénéficiaire">Adr. livraison</span>
            <smart-select class="hdr-select" height="30px" optionHeight="32px" [items]="beneficiaryAddresses" formControlName="addr_deliv" [bindLabelFn]="formatAddress" bindValue="id"></smart-select>
          </div>
          <div class="field-beneficiary-spacer"></div>
        </div>
      }
    </div>
  </div>
  <!-- Rien d'autre à l'écran ne dit qu'une pièce vient de l'ancien logiciel : le bandeau de
      type ne dérive que du doc_type, et une facture reprise porte le même que les commandes
      vivantes. Sans ce message, la disparition des gestes se lit comme une panne. -->
  @if (isReadOnly) {
    <div class="readonly-banner tertiary-light">
      <mat-icon>lock</mat-icon>
      <span>Document repris de l'ancien logiciel — consultation seule. Aucune modification n'est possible.</span>
    </div>
  }
  <!-- canSave : l'état l'autorise (allowed_actions du serveur, sinon isOrderEditable) ; le reste : pièce non reprise, commande avec client et adresse. -->
  <app-action-bar form="mainform" (submitEmitter)="onActionBarSubmit($event)" [hassave]="true" [canSave]="canSave && !isReadOnly" [saveTooltip]="orderBlockedReason ?? ''" [actionBarState$]="actionBarState$">
    @if (true) {
      <app-quotation-action (submitEmitter)="onActionBarAction($event)" [formGroup]="formGroup" [remainder]="remainder" [blockReason]="orderBlockedReason" [deliveryBlockReason]="deliveryBlockedReason" [deliveryVisible]="deliveryVisible"></app-quotation-action>
    }
  </app-action-bar>
  <!-- <div class="pagecontent">	Main tab group -->
  <div class="flexrow">
    <!-- Panneau latéral historique / documents (doc front.sales.quotation-panneau-lateral) : `sideTab` n'est posé qu'au changement de pièce,
      `preserveContent` garde monté un onglet déjà ouvert, sans refaire la requête d'historique. -->
    @if (hasCustomer || id > 0) {
      <div class="grow1 side-panel" [ngClass]="hasCustomer ? 'success' : 'neutral'" style="width: 35%">
        <mat-tab-group class="side-tabs" preserveContent [selectedIndex]="sideTab" (selectedIndexChange)="sideTab = $event">
          <!-- matTabContent : contenu créé à l'ouverture de l'onglet, la coûteuse requête d'historique ne part que si on la demande. -->
          <mat-tab label="Historique client">
            <ng-template matTabContent>
              <app-salehistory [customer]="customer" [id]="id"></app-salehistory>
            </ng-template>
          </mat-tab>
          <mat-tab label="Documents attachés">
            <ng-template matTabContent>
              <app-quotationdocs [orderId]="id" [closedLinesLoaded]="closedLinesLoaded" [canEdit]="!isReadOnly" [loadOrderEventsSubject$]="loadOrderEventsSubject.asObservable()" (openDelivery)="openDeliveryDialog($event)"></app-quotationdocs>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    }
    <form class="grow1" [formGroup]="formGroup" (ngSubmit)="onFormSubmit()" id="mainformXX" style="width: 70%">
      <!-- <div class="maincontent"> -->
      <div>
        <mat-tab-group [selectedIndex]="selectedtab" (selectedIndexChange)="selectedIndexChange($event)">
          <mat-tab label="Produits" matTooltip="Produits">
            @if (docType === DocType.LOCATION) {
              <app-rentgeneral [closedLinesLoaded]="closedLinesLoaded" (loadClosedLines)="loadClosedLines()" [is_ht]="is_ht" [group_packagings]="group_packagings" [loadOrderEventsSubject$]="loadOrderEventsSubject.asObservable()" [loadCustomerEventsSubject$]="loadCustomerEventsSubject.asObservable()" (onSubmit)="onSubmit()" (onReload)="create_or_load_order(id)" [actionBarState$]="actionBarState$"></app-rentgeneral>
            }
            <app-quotationgeneral [is_ht]="is_ht" [group_packagings]="group_packagings" [loadOrderEventsSubject$]="loadOrderEventsSubject.asObservable()" [loadCustomerEventsSubject$]="loadCustomerEventsSubject.asObservable()" (onSubmit)="onSubmit()" (onReload)="create_or_load_order(id)" [actionBarState$]="actionBarState$" (remainderChange)="remainder = $event"></app-quotationgeneral>
          </mat-tab>
          <!-- old when we plan liv in the quotation page -->
          <!-- <mat-tab [label]="formGroup.controls['addr_deliv'].value ? 'Livraison ': 'Client avec adresse indispensable pour programmer une livraison' " *ngIf="false && formGroup.value.state === constants.SALES_ORDER_STATE_PREPARATION && id>0" [disabled]="!formGroup.controls['addr_deliv'].value"  >
            <app-planificationdelivery  [loadOrderEventsSubject$]="loadOrderEventsSubject.asObservable()" [submitEventSubject$]="submitEventSubject.asObservable()" (ParentIsValidable)="deliveryChangeIsValidable($event)" [actionBarState$]="actionBarState$" ></app-planificationdelivery>
          </mat-tab>					 -->
          @if (false) {
            <mat-tab label="Options">
              <app-quotationoptions></app-quotationoptions>
            </mat-tab>
          }
          <!-- L'onglet « Documents » a quitté ce groupe : les pièces vivent dans le panneau latéral,
          où elles se lisent à côté de la saisie. Le bloc mort qui restait ici instanciait
          app-quotationdocs SANS orderId — il n'aurait plus rien affiché. -->
        </mat-tab-group>
      </div>
    </form>
  </div>
}
@if (NoDocumentError) {
  <div style="padding: 20px; font-size: x-large">ERREUR : Document inexistant</div>
}

@if (!dataOk && !dataError && !NoDocumentError && (serverStatusService.isOnline$ | async)) {
  <div class="loading">Chargement du document...</div>
}

<app-offline-banner></app-offline-banner>
